import { render, staticRenderFns } from "./berakna-skarbit.vue?vue&type=template&id=266369cd&shadow"
import script from "./berakna-skarbit.vue?vue&type=script&lang=js&shadow"
export * from "./berakna-skarbit.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports